<template>
  <div class="animated fadeIn">
    <b-row>
        
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'profile',
  data: function () {
    return {
      show: true
    }
  },
  methods:{
     ...mapActions([
      'getMessages'
    ])
  },
  computed:{
   ...mapState([
     'messages'
   ])
  },
  mounted(){
    // this.getMessages()
    console.log('this.messages',this.messages)
  }
}
</script>




<style scoped>
  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
